/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ActiveInputs */



/**
* | output |
* | --- |
* | "Filter active" |
*
* @param {Editor_Filter_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_active = /** @type {((inputs?: Editor_Filter_ActiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ActiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtre actif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filter aktiv")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtro attivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтр активен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtro activo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("过滤器已激活")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルターが有効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़िल्टर सक्रिय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtro ativo")
	return /** @type {LocalizedString} */ ("Filter active")
});